import { render, staticRenderFns } from "./DocumentVerificationFactors.vue?vue&type=template&id=0a254116&"
import script from "./DocumentVerificationFactors.vue?vue&type=script&lang=js&"
export * from "./DocumentVerificationFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports